import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../context/I18nContext';
import { AnimatedSocialIcon } from '../icons/animated-social-icons';
const developerPageLink = 'https://abdullahmaher.carrd.co/';
const CatLogo = ({ size = 32 }: { size?: number }) => (
  <img
    src="/logo.png"
    alt="CAT CARE"
    width={size}
    height={size}
    className="object-contain"
  />
);

export const Footer: React.FC = () => {
  const { t } = useI18n();
  const currentYear = new Date().getFullYear();

  const links = [
    { label: t('footer.aboutUs'), to: '/about' },
    { label: t('footer.contactUs'), href: 'https://wa.me/+201025400119' },
    { label: t('footer.privacyPolicy'), to: '/privacy-policy' },
    { label: t('footer.termsOfService'), to: '/terms' },
  ];

  return (
    <footer className="bg-base-900 text-base-100" role="contentinfo">
      <div className="container-page py-12 lg:py-16">
        {/* Top: Logo + Social */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 mb-8">
          <Link
            to="/"
            className="flex items-center gap-2 text-heading-lg font-bold text-white"
            aria-label={t('nav.home')}
          >
            <CatLogo size={28} />
            <span className="tracking-tighter">CAT CARE</span>
          </Link>

          <div className="flex items-center gap-3">
            <AnimatedSocialIcon
              name="whatsapp"
              href="https://wa.me/+201025400119"
              label="WhatsApp"
              size={22}
              trigger="mount"
            />
            <AnimatedSocialIcon
              name="facebook"
              href="https://www.facebook.com/profile.php?id=61583695298740"
              label="Facebook"
              size={22}
              trigger="mount"
            />
            <AnimatedSocialIcon
              name="instagram"
              href="https://www.instagram.com/catcare98"
              label="Instagram"
              size={22}
              trigger="mount"
            />
          </div>
        </div>

        {/* Middle: Links */}
        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 mb-8 pb-8 border-b border-base-800">
          {links.map((link) =>
            link.to ? (
              <Link
                key={link.to}
                to={link.to}
                className="text-base-400 hover:text-white transition-colors duration-150 text-body-sm"
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.href}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-base-400 hover:text-white transition-colors duration-150 text-body-sm"
              >
                {link.label}
              </a>
            )
          )}
        </nav>

        {/* Bottom: Copyright + Developer Credit */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-5 pt-1">
          <p className="text-base-500 text-body-sm">
            © {currentYear} CAT CARE. {t('footer.rightsReserved')}
          </p>

          <p className="text-base-300 text-body-sm font-medium">
            <a href={developerPageLink}>  {t('footer.madeWithCare')}</a>

          </p>
        </div>
      </div>
    </footer>
  );
};
